/*
 * @Descripttion:常用工具类
 */
import dayjs from 'dayjs';

type StrOrNum = string | number

/**
 * @description: 利用dayjs格式化时间
 * @param {Date} time 时间
 * @param {string} format 格式 YYYY-MM-DD HH:mm:ss
 * @return {*}
 */
export const formatDate = (time: Date | string | number, format = 'YYYY-MM-DD HH:mm:ss'): string => dayjs(time).format(format);

/**
 * @description: 判断传入内容是否是 undefined、null或者空字符串
 * @param {array} str
 */
export const isEmpty = (...str: Array<any>): boolean => str.some((i) => i === undefined || i === null || i === '');

/**
 * @description: 复制
 * @param {*} copyInfo
 */
export const copyHandle = (copyInfo: string): void => {
  const $textarea = document.createElement('textarea');
  $textarea.value = copyInfo;
  document.body.appendChild($textarea);
  $textarea.select();
  document.execCommand('Copy'); // 执行浏览器复制命令
  $textarea.style.display = 'none';
  document.body.removeChild($textarea);
};

/**
 * @description: 通过图片获取网速
 * @param {*} fileSize 单位KB
 * @return B/ms
 */
export const getSpeedWithImg = (imgUrl: string, fileSize: number): any => new Promise((resolve) => {
  const start = Date.now();
  let end = null;
  const img = document.createElement('img');
  img.onload = () => {
    end = Date.now();
    const speed = (fileSize * 1000) / (end - start);
    resolve(speed);
  };
  img.src = imgUrl;
}).catch((err) => { throw err; });

/**
 * @description: 获取两个日期之间的所有日期
 * @param {Date} startTime GMT日期格式
 * @param {Date} endTime GMT日期格式
 */
export const getAllDateCN = (startTime: Date, endTime: Date) => {
  const dateAll = [];
  let i = 0;
  while (endTime.getTime() - startTime.getTime() >= 0) {
    // 获取日期和时间
    const year = startTime.getFullYear();
    const month = startTime.getMonth() + 1;
    const day = startTime.getDate();
    const time = startTime.toLocaleTimeString();

    const fullMonth = month < 10 ? `0${month}` : month;
    const fullDay = day < 10 ? `0${day}` : day;
    dateAll[i] = `${year}-${fullMonth}-${fullDay} ${time}`;

    // 天数+1
    startTime.setDate(startTime.getDate() + 1);
    i += 1;
  }
  return dateAll;
};

/**
 * @description: 求两个数组的交集
 * @param {StrOrNum} arrayFirst
 * @param {StrOrNum} arraySecond
 */
export const intersection = (arrayFirst: StrOrNum[], arraySecond: StrOrNum[]) => {
  const matched = arrayFirst.filter((af: string | number) => arraySecond.some((as: string | number) => af === as));
  return matched;
};
/**
 * 文件后缀的格式校验
 * @param file 文件
 * @param acceptedFormats 后缀列表，不传参的话，取默认值
 */
export const checkFileFormat = (file:any, acceptedFormats:any) => {
  if (!acceptedFormats){
    //word、excel、csv、ppt 2003、ppt2007、pdf、txt、jpg、png
    acceptedFormats = ['doc','docx','xls','xlsx','csv','ppt','pptx','pdf','txt','jpg', 'jpeg', 'png', 'gif','zip','rar','tar','7z']
  }
  if (!file || !file.name) {
    return false
  }
  if (file.name.indexOf('.') === -1) {
    return false
  }
  const fileExtension = file.name.split('.').pop(); // 获取文件的扩展名
  console.log('fileExtension---',fileExtension)
  console.log('result---',acceptedFormats.includes(fileExtension))
  return acceptedFormats.includes(fileExtension);
  // return false
};
/**
 * 获取字符串的第一个域名
 */
export const getFirstLevelDomain = (url:string) => {
  const regex = /^(?:https?:\/\/)?(?:[a-z0-9\-]+\.)*([a-z0-9]+\.[a-z]{2,})(?:\/.*)?$/i;
  const match = url.match(regex);
  if (match) {
    return match[1];
  }
  return '';
}

